<template>
    <span></span>
</template>

<script>
    import setInputValue from "../utils/setInputValue";

    export default {
        props: {
            target: {default: ''}
        },
        data() {
            return {}
        },
        computed: {},
        mounted() {
            const value = `${$(window).width()} x ${$(window).height()}`;
            console.log({target: this.target, value});
            setInputValue(this.target, value);
        },
        methods: {},
        watch: {},
        components: {}
    }
</script>
